// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='FiltersPopover'] {\n  float: right;\n}\n  [name='FiltersPopover'] .saved-filters {\n    float: right;\n    color: var(--primary-font-color);\n    cursor: pointer;\n    padding: 20px 15px 0px 10px;\n    background-repeat: no-repeat;\n    background-position: 100% 26px;\n    font-size: 14px;\n  }\n  [name='FiltersPopover'] .name{\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n", ""]);
// Exports
module.exports = exports;
